import React, { useState, useMemo, forwardRef } from 'react';
import { EstadoCarregando } from '../../home/tabela/EstadosTabela.js';
import { FaRegCalendarAlt, FaTimes } from 'react-icons/fa';
import styled from 'styled-components';
import ResponsiveDatePicker from '../components/ResponsiveDatePicker';

const TrashSvg = ({ title, onClick, className, style }) => (
  <svg width="19" height="26" viewBox="0 0 19 26" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick} className={className} style={style} role="img" aria-label={title}>
    <path d="M3.16602 7.39795H15.8327" stroke="#DB1212" strokeWidth="1.57" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.91602 11.625V17.966" stroke="#DB1212" strokeWidth="1.57" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.084 11.625V17.966" stroke="#DB1212" strokeWidth="1.57" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3.95898 7.39795L4.75065 20.08C4.75065 20.6406 4.91747 21.1782 5.2144 21.5746C5.51133 21.971 5.91406 22.1937 6.33398 22.1937H12.6673C13.0872 22.1937 13.49 21.971 13.7869 21.5746C14.0838 21.1782 14.2507 20.6406 14.2507 20.08L15.0423 7.39795" stroke="#DB1212" strokeWidth="1.57" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.125 7.39775V4.22725C7.125 3.94696 7.20841 3.67815 7.35687 3.47995C7.50534 3.28176 7.7067 3.17041 7.91667 3.17041H11.0833C11.2933 3.17041 11.4947 3.28176 11.6431 3.47995C11.7916 3.67815 11.875 3.94696 11.875 4.22725V7.39775" stroke="#DB1212" strokeWidth="1.57" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const EditSvg = ({ title, onClick, className, style }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick} className={className} style={style} role="img" aria-label={title}>
    <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="#4A4A4A" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.5 2.50023C18.8978 2.1024 19.4374 1.87891 20 1.87891C20.5626 1.87891 21.1022 2.1024 21.5 2.50023C21.8978 2.89805 22.1213 3.43762 22.1213 4.00023C22.1213 4.56284 21.8978 5.1024 21.5 5.50023L12 15.0002L8 16.0002L9 12.0002L18.5 2.50023Z" stroke="#4A4A4A" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: 8px;
`;

const StatusText = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${props => {
    switch(props.status) {
      case 'Confirmado': return '#24A788';
      case 'Cancelado': 
      case 'Cancelado_Coordenador': return '#A72424';
      case 'Pendente': return '#9D9D09';
      default: return '#666';
    }
  }};
`;

const PublicadorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const IconeStatusPublicador = styled.svg`
  width: 14px;
  height: 14px;
  flex-shrink: 0;
`;

const IconeStatusDesignacao = styled.svg`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

const renderIconeStatus = (status, isDesignacao = false) => {
  const size = isDesignacao ? 16 : 14;
  const IconComponent = isDesignacao ? IconeStatusDesignacao : IconeStatusPublicador;

  switch (status) {
    case 'Confirmado':
      return (
        <IconComponent xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <path d="M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#24A788" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M8.66699 12.633L10.172 14.354C10.271 14.4673 10.3944 14.5568 10.5328 14.6159C10.6713 14.6749 10.8213 14.7019 10.9716 14.6949C11.1219 14.6879 11.2688 14.647 11.4011 14.5753C11.5335 14.5037 11.6479 14.4031 11.736 14.281L15.333 9.29999" stroke="#24A788" strokeLinecap="round" strokeLinejoin="round" />
        </IconComponent>
      );
    case 'Cancelado':
      return (
        <IconComponent xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <path d="M15 9L9 15M9 9L15 15M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#A72424" strokeLinecap="round" strokeLinejoin="round" />
        </IconComponent>
      );
    case 'Cancelado_Coordenador':
      return (
        <IconComponent xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <path d="M15 9L9 15M9 9L15 15M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#8B0000" strokeLinecap="round" strokeLinejoin="round" />
        </IconComponent>
      );
    case 'Pendente':
    default:
      return (
        <IconComponent xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <path d="M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#9D9D09" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M12 16V11H11.5M11.5 16H12.5M12 8.5V8" stroke="#9D9D09" strokeLinecap="round" strokeLinejoin="round" />
        </IconComponent>
      );
  }
};

const CardDesignacoes = ({
  styles,
  designacoes,
  loading,
  hasLoaded,
  perfilCarregado,
  selectedDesignacoes,
  toggleSelectDesignacao,
  formatDate,
  handleExcluirDesignacao,
  handleEditarDesignacao
}) => {
  const {
    Card,
    CardHeader,
    CardBody,
    DesignacaoItem,
    DesignacaoItemHeader,
    DesignacaoItemSpan,
    DesignacaoItemCheckbox,
    DesignacaoItemBody,
    DesignacaoItemLabel,
    DesignacaoItemPublicador,
    DesignacaoItemCongregacao,
    DesignacaoItemData,
    DesignacaoItemPeriodos,
    DesignacaoItemActions,
    DesignacaoItemExtra
  } = styles;

  const [filterDate, setFilterDate] = useState(null);

  const CalendarIconButton = forwardRef(({ value, onClick }, ref) => (
    <FaRegCalendarAlt
      ref={ref}
      title={filterDate ? 'Alterar data do filtro' : 'Filtrar por data'}
      style={{ cursor: 'pointer', fontSize: 18, color: '#fff' }}
      onClick={onClick}
    />
  ));

  const obterStatusDesignacao = (designacao) => {
    const statusIndividuais = (designacao?.publicadores || []).map(
      (publicador) => publicador?.statusIndividual || 'Pendente'
    );

    const totalPublicadores = statusIndividuais.length;

    const confirmados = statusIndividuais.filter(
      (status) => status === 'Confirmado'
    ).length;
    const cancelados = statusIndividuais.filter(
      (status) => status === 'Cancelado' || status === 'Cancelado_Coordenador'
    ).length;
    const pendentes = statusIndividuais.filter(
      (status) => status === 'Pendente'
    ).length;

    // Mesma lógica da tabela Home
    if (totalPublicadores === 3) {
      if (cancelados >= 2) return 'Cancelado';
      if (confirmados >= 2) return 'Confirmado';
      return 'Pendente';
    }

    if (totalPublicadores === 2) {
      if (confirmados === 2) return 'Confirmado';
      if (cancelados >= 1) return 'Cancelado';
      return 'Pendente';
    }

    if (totalPublicadores > 0 && cancelados === totalPublicadores) {
      return 'Cancelado';
    }

    if (confirmados >= 2) return 'Confirmado';

    if (confirmados === 1 && cancelados >= 1 && pendentes === 0) {
      return 'Aguardando_Cancelamento';
    }

    const statusGeral = designacao?.status;
    if (
      [
        'Cancelado_Coordenador',
        'Cancelado',
        'Confirmado',
        'Aguardando_Cancelamento',
        'Pendente',
      ].includes(statusGeral)
    ) {
      return statusGeral;
    }

    return 'Pendente';
  };

  const filteredDesignacoes = useMemo(() => {
    const hoje = new Date();
    hoje.setHours(0,0,0,0);
    const parseLocalDate = (dateInput) => {
      const datePart = String(dateInput).substring(0, 10); // "YYYY-MM-DD"
      const [y, m, day] = datePart.split('-').map(Number);
      return new Date(y, m - 1, day);
    };

    const base = (designacoes || []).filter(d => {
      if (!d || !d.data) return false;
      const dtNoTime = parseLocalDate(d.data).getTime();
      return dtNoTime >= hoje.getTime();
    });

    if (!filterDate) return base;

    const tgt = new Date(filterDate.getFullYear(), filterDate.getMonth(), filterDate.getDate()).getTime();
    return base.filter(d => {
      const cmp = parseLocalDate(d.data).getTime();
      return cmp === tgt;
    });
  }, [designacoes, filterDate]);

  return (
    <Card>
      <CardHeader style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Designações</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {filterDate && (
            <span style={{ fontSize: 12, color: '#f1f7f9' }}>{}
              {filterDate.toLocaleDateString('pt-BR')}
            </span>
          )}
          {filterDate && (
            <FaTimes
              title="Limpar filtro de data"
              style={{ cursor: 'pointer', fontSize: 16, color: '#f1f7f9' }}
              onClick={() => setFilterDate(null)}
            />
          )}
          <ResponsiveDatePicker
            style={{ width: 'auto' }}
            value={filterDate}
            onChange={(d) => setFilterDate(d)}
            customInput={<CalendarIconButton />}
            popoverRight
          />
        </div>
      </CardHeader>
      <CardBody>
        {(!perfilCarregado || !hasLoaded || loading) ? (
          <EstadoCarregando />
        ) : filteredDesignacoes && filteredDesignacoes.length > 0 ? (
          filteredDesignacoes.map((des) => {
            const statusDesignacao = obterStatusDesignacao(des);
            return (
              <DesignacaoItem key={des._id}>
                <DesignacaoItemHeader>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <DesignacaoItemSpan>{des.ponto?.nome || 'Ponto'}</DesignacaoItemSpan>
                    <StatusContainer>
                      {renderIconeStatus(statusDesignacao, true)}
                      <StatusText status={statusDesignacao}>
                        {statusDesignacao === 'Cancelado_Coordenador' ? 'Cancelado' : statusDesignacao}
                      </StatusText>
                    </StatusContainer>
                  </div>
                  <DesignacaoItemCheckbox type="checkbox" checked={selectedDesignacoes.includes(des._id)} onChange={() => toggleSelectDesignacao(des._id)} />
                </DesignacaoItemHeader>
                <DesignacaoItemBody>
                  <DesignacaoItemLabel>Publicadores:</DesignacaoItemLabel>
                  {(des.publicadores || []).map(pub => (
                    <React.Fragment key={pub._id || pub.nome}>
                      <PublicadorContainer>
                        {renderIconeStatus(pub.statusIndividual || 'Pendente', false)}
                        <DesignacaoItemPublicador className="publicador">{pub.nome}</DesignacaoItemPublicador>
                      </PublicadorContainer>
                      <DesignacaoItemCongregacao>{pub.congregacao?.nome || '-'}</DesignacaoItemCongregacao>
                    </React.Fragment>
                  ))}
                  <DesignacaoItemData><strong>{formatDate(des.data)}</strong></DesignacaoItemData>
                  <DesignacaoItemPeriodos className="periodos">
                    {(des.horario || [])
                      .sort((a, b) => {
                        const ordem = {
                          '6h - 8h': 1,
                          '8h - 10h': 2,
                          '10h - 12h': 3,
                          '12h - 14h': 4,
                          '14h - 16h': 5,
                          '16h - 18h': 6,
                          '18h - 20h': 7
                        };
                        return (ordem[a] || 999) - (ordem[b] || 999);
                      })
                      .join('; ')}
                  </DesignacaoItemPeriodos>
                  <DesignacaoItemActions>
                    <TrashSvg
                      title="Excluir"
                      className="icon designacao-item-trash"
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleExcluirDesignacao(des._id)}
                    />
                    <EditSvg
                      title="Editar"
                      className="icon designacao-item-edit"
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleEditarDesignacao(des)}
                    />
                  </DesignacaoItemActions>
                  <DesignacaoItemExtra>
                  {(() => {
                    const nomeCriador = (des?.criadoPor?.nome || '').trim();
                    const dataCriacao = des?.createdAt;
                    
                    const nomeAtualizador = (des?.atualizadoPor?.nome || '').trim();
                    const dataAtualizacao = des?.atualizadoPor?.dataHora;

                    // Função para formatar data/hora (Brasil)
                    const formatarDataHoraBR = (dataString) => {
                      if (!dataString) return null;
                      try {
                        const d = new Date(dataString);
                        return d.toLocaleString('pt-BR', { 
                          day: '2-digit', month: '2-digit', year: 'numeric', 
                          hour: '2-digit', minute: '2-digit' 
                        });
                      } catch (e) { return null; }
                    };

                    const criacaoStr = formatarDataHoraBR(dataCriacao);
                    const atualizacaoStr = formatarDataHoraBR(dataAtualizacao);
                    const temAtualizadorValido = nomeAtualizador && nomeAtualizador.toLowerCase() !== 'desconhecido';

                    return (
                      <div style={{ fontSize: '11px', color: '#666', fontStyle: 'italic', marginTop: '4px' }}>
                        {nomeCriador && nomeCriador.toLowerCase() !== 'desconhecido' && (
                          <span style={{ display: 'block' }}>
                            Criado por: {nomeCriador} {criacaoStr && `em ${criacaoStr}`}
                          </span>
                        )}
                        
                        {temAtualizadorValido && (
                          <span style={{ display: 'block' }}>
                            Última alteração: {nomeAtualizador} {atualizacaoStr && `em ${atualizacaoStr}`}
                          </span>
                        )}
                      </div>
                    );
                  })()}
                </DesignacaoItemExtra>
                </DesignacaoItemBody>
              </DesignacaoItem>
            );
          })
        ) : (
          <p>Nenhuma designação cadastrada.</p>
        )}
      </CardBody>
    </Card>
  );
};

export default CardDesignacoes;
